/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const monitorUserList=usersList.injectEndpoints({
    tagTypes:['MonitorUser','AssociatedMonitorOrg','SelectedMonitorOrg','MonitorOrganizationList','MonitorActivityHistory','MonitorHistoryExport','patient','AssociatedMonitorPatient'],
    endpoints:(builder)=>({
        getMonitors: builder.query({
            query: (searchParams) => `monitor-users?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'MonitorUser',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'MonitorUser', id:_id}))
            ]:[]
            
        }),

        getMonitor:builder.query({
            query:(id)=>`/monitor-users/${id}`,
            
            providesTags: (result, error, arg) => [{ type: 'MonitorUser', id: arg }],
            invalidatesTags:['MonitorActivityHistory']
        }),

        addMonitorUser:builder.mutation({
            query:org=>({
                url:`/monitor-users/`,
                method:'POST',
                body:org
            }),
            invalidatesTags:['MonitorUser','MonitorActivityHistory']
        }),

        editMonitorUser:builder.mutation({
            query:({id,body})=>({
                url:id!==undefined?`/monitor-users/${id}`:`/monitor-users/`,
                method:'PATCH',
                body:body
            }),
            invalidatesTags:(result,error,arg)=>[{type:'MonitorUser',id:arg.id},'MonitorActivityHistory']
        }),
        
        exportMonitor:builder.mutation({
            query:({queryString,columns,dateformat})=>({
                url:`monitor-users/export-monitoruser-list?${queryString}`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone},

            }),
            invalidatesTags:['MonitorActivityHistory']
        }),

        exportOrgList:builder.mutation({
            query:({queryString,columns})=>({
                url:`monitor-users/export-organization-list/${queryString}`,
                method:'POST',
                body:{"columns":columns}
            }),
            invalidatesTags:['MonitorActivityHistory']
        }),
        
        exportMonitorActivityHistory:builder.mutation({
            query:({queryString,columns,dateformat})=>({
                
                url:`monitor-users/export-profile-changes?${queryString}`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone}
            }),
            invalidatesTags:['MonitorActivityHistory']
        }),

        getMonitorActivityHistory: builder.query({
            query: (searchParams) => `monitor-users/list-changes?${searchParams}`,
            providesTags: ['MonitorActivityHistory']

        }),
        getMonitorOrganizations:builder.query({
            query:(searchParams)=>`organizations?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'MonitorOrganizationList',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'MonitorOrganizationList',id:_id}))
            ]:[],
        }),

        getMonitorSubdivisions:builder.query({
            query: (searchParams) => `monitor-users/list-subdivisions?${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'SelectedMonitorOrg',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'SelectedMonitorOrg', id:_id}))
            ]:[], 
        }),

        linkMonitortoOrganization: builder.mutation({
            query: ({id,body}) => ({
                url: `monitor-users/${id}`,
                method: 'POST',
                body:body
            }),
            invalidatesTags: ['MonitorActivityHistory']
        }),

        getMonitorAssociatedOrganizations: builder.query({
            query: (searchParams) => `monitor-users/list-organization/${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedMonitorOrg',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({organization_id})=>({type:'AssociatedProviderOrg', id:organization_id}))
            ]:[],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),

        deleteMonitorAssociatedOrganization: builder.mutation({
            query: ({id,organization_id,subdivision_id}) => {
                return {
                    url: `monitor-users/${id}?organization_id=${organization_id}&subdivision_id=${subdivision_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'AssociatedMonitorOrg', id: arg.organization_id },'MonitorActivityHistory','AssociatedMonitorPatient'],
        }),
        getMonitorViewExportHistory: builder.query({
            query: (searchParams) => `monitor-users/list-export-history?${searchParams}`,
            providesTags: ['MonitorHistoryExport']
        }),
        exportMonitorExportLog:builder.mutation({
            query:({columns,dateformat,username})=>({
                url:`monitor-users/export-export-history`,
                method:'POST',
                body:{"columns":columns,"dateformat":dateformat,"timezone":Intl.DateTimeFormat().resolvedOptions().timeZone,"target_user":username}
            }),
        }), 
        getMonitorAssociatedPatientList: builder.query({
            query: (queryParamsPassed) => `monitor-users/list-patients/${queryParamsPassed}`,
            providesTags:(result=[],error,arg)=>error===undefined?[    
                'patient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'patient', id:_id}))
            ]:[]
            
        }),
        associatePatientToMonitor:builder.mutation({
            query:({monitorId,body})=>({
                url:`/monitor-users/link-patients/${monitorId}`,
                method:'POST',
                body:body
            }),
            invalidatesTags:['patient','AssociatedMonitorPatient']
        }),
        getPatientAssociatedMonitor: builder.query({
            query: (searchParams) => `monitor-users/associated-patients/${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedMonitorPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'AssociatedMonitorPatient', id:_id}))
            ]:[],
        }),
        deletePatientAssociatedToMonitor: builder.mutation({
            query: ({monitor_id,patient_id}) => {
                return {
                    url: `monitor-users/unlink-patient/${monitor_id}?patient_id=${patient_id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags:['patient','AssociatedMonitorPatient','MonitorActivityHistory']

        }),
        // getMonitorAssociatedPatients: builder.query({
        //     query: (searchParams) => `monitor-users/associated-patients/${searchParams}`,
        //     providesTags:(result=[],error,arg)=>error===undefined?[
        //         'AssociatedMonitorPatient',
        //         ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'AssociatedMonitorPatient', id:_id}))
        //     ]:[],
        // }),
        exportPatientsAssociatedToMonitor: builder.mutation({
            query: ({ queryString,columns,dateformat,monitor_id }) => ({
                url: `monitor-users/export-linked-patient/${monitor_id}${queryString!==''?`?${queryString}`:''}`,
                method: 'POST',
                body: {
                    "columns": columns,
                    "dateformat": dateformat,
                    "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone 
                }
            }),
        }),

    }),

    overrideExisting: false
})


export const {
    useExportMonitorActivityHistoryMutation,
    useGetMonitorQuery,
    useGetMonitorActivityHistoryQuery,
    useGetMonitorOrganizationsQuery,
    useLazyGetMonitorSubdivisionsQuery,
    useLinkMonitortoOrganizationMutation,
    useEditMonitorUserMutation,
    useGetMonitorsQuery,
    useLazyGetMonitorAssociatedOrganizationsQuery,
    useGetMonitorAssociatedOrganizationsQuery,
    useDeleteMonitorAssociatedOrganizationMutation,
    useAddMonitorUserMutation,
    useExportMonitorMutation,
    useExportOrgListMutation,
    useGetMonitorViewExportHistoryQuery,
    useExportMonitorExportLogMutation,
    useGetMonitorAssociatedPatientListQuery,
    useAssociatePatientToMonitorMutation,
    useLazyGetPatientAssociatedMonitorQuery,
    useDeletePatientAssociatedToMonitorMutation,
    useLazyGetMonitorQuery,
    useExportPatientsAssociatedToMonitorMutation,
}=monitorUserList